import React from 'react';
import SongDetails from './SongDetails';

const SongInfoReportEdit = ({title, composers, artist}) => {

  return (
    <>
      <h3 className="text-center">
        You are editing report for:
      </h3>
      <SongDetails title={title} composers={composers} artist={artist} />
    </>
  );
};

export default SongInfoReportEdit;
